import 'url-polyfill';

export function getParams(param) {
  return new URL(window.location.href).searchParams.get(param);
}

export function getDomain() {
  return new URL(window.location.href).searchParams.get('domain') || 'bestfotokonyv.hu';
}



// WEBPACK FOOTER //
// ./src/redux/helpers/getParams.js